import { render, staticRenderFns } from "./WaiveRequestPage.vue?vue&type=template&id=1f93caa7&scoped=true"
import script from "./WaiveRequestPage.vue?vue&type=script&lang=js"
export * from "./WaiveRequestPage.vue?vue&type=script&lang=js"
import style0 from "./WaiveRequestPage.vue?vue&type=style&index=0&id=1f93caa7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f93caa7",
  null
  
)

export default component.exports